import type {match} from "../../../../../../services/flowTypes/appFlowTypes";
import {useState} from "react";
import RenderOnReady from "../../../../../../components/service/RenderOnReady/RenderOnReady";
import DocumentFunctional
  from "../../../../../../components/composed/ItemDocuments/DocumentEdit/Document/DocumentFunctional";
import NCard from "../../../../../../components/simple/Containers/NCard/NCard";
import text from "../../../../../../services/localization/text";
import EmptyListV2 from "../../../../../../components/simple/Containers/EmptyList/EmptyListV2";
import Text1 from "../../../../../../components/simple/TextComponents/Text1/Text1";
import DeleteDocument
  from "../../../../../../components/composed/ItemDocuments/DocumentEdit/DeleteDocument/DeleteDocument";
import {documentsPageIds} from "../../../../../../tests/testIds";
import {permissionsStrValues} from "../../../../../../configData/permissionsStrValues";
import NHeading1 from "../../../../../../components/simple/TextComponents/NHeading1/NHeading1";
import Can from "../../../../../../services/permissions/Can";
import TemplateUploader from "../../../../../../components/composed/ItemDocuments/TemplateUploader";
import useOrganizationTemplates from "../../../../../../hooks/useOrganizationTemplates";

type Props = {
  match: match
}
const OrganizationAvailableTemplates = ({
                                          match
                                        }: Props) => {
  const {organizationId} = match.params;
  const [actual, setActual] = useState(Date.now())
  const {isReadyToRender, errorObject, setErrorObject, data} = useOrganizationTemplates(organizationId, actual)

  const refreshData = () => {
    setActual(Date.now())
  }
  return (
    <div className="pt_1du mb_3du">
      <div className="flex_jc-sb mb_3du">
        <NHeading1>{text.availableTemplates}</NHeading1>
        <Can do={'usePermission'} on={permissionsStrValues.organizationDocument.create}>
          <TemplateUploader 
            organizationId={organizationId} 
            onTemplateUploaded={refreshData}
            existingTemplates={data}
          />
        </Can>
      </div>

      <RenderOnReady isReadyToRender={isReadyToRender} errorObject={errorObject}>
        {data.length
          ? (
            <NCard addClasses={'NCard__wide-width'}>
              {data.map(({id, name}, i) => {
                const documentBtns = <DeleteDocument itemType={'organizations'}
                                                     itemId={organizationId}
                                                     fileId={id}
                                                     fileName={name}
                                                     onCancelBtnClick={() => {
                                                     }}
                                                     unmountDocumentsListFetcher={() => {
                                                       //nothing do
                                                     }}
                                                     mountDocumentsListFetcher={() => {
                                                       //nothing do
                                                     }}
                                                     onUpdateDocumentFoldersList={refreshData}
                                                     permittedAction={permissionsStrValues.organizationDocument.delete}
                                                     idForTest={documentsPageIds.buttonDeleteOrganizationDocTemplate(i)}
                                                     setErrorObject={setErrorObject}
                />;
                return <DocumentFunctional
                  key={id}
                  itemId={organizationId}
                  itemType={'organizations'}
                  showTime={false}
                  organizationId={organizationId}
                  document={{
                    id,
                    name,
                    fileId: id
                  }}
                  documentBtns={documentBtns}
                />
              })
              }
            </NCard>
          )
          : (
            <EmptyListV2 insertedLabelComponent={
              <Text1 addClasses={"mt_3du"}>{text.emptyListLabel.itemDocuments}</Text1>
            }/>
          )
        }
      </RenderOnReady>
    </div>
  )
}

export default OrganizationAvailableTemplates
